import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Modalconfig } from 'src/app/shared/constants';
import { PlaybookCommunicationService } from '../../shared/services/playbook-communication.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage/session-storage.service';
import { sessionProfile } from 'src/app/shared/interfaces/sessionStorageModel';
import { devicePixelRatio } from 'src/app/shared/constants';
import { AddEditChallengeBlockComponent } from './add-edit-challenge-block/add-edit-challenge-block.component';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'ngx-webstorage';
import { clone } from 'lodash';


@Component({
    selector: 'app-challenge-block',
    templateUrl: './challenge-block.component.html',
    styleUrls: ['./challenge-block.component.scss'],
    standalone: false
})
export class ChallengeBlockComponent implements OnInit, OnDestroy {

  @Input() contentBlock;
  @Input() sectionId;
  @Input() level;
  @Input() container;
  @Input() pageTemplateId: number;
  challengeContentSubscription: Subscription;

  buttonText: string;
  devicePixelRatio = devicePixelRatio;
  private updateSubsciption: Subscription;
  private modalSubscription: Subscription;
  private addEditChallengeRef: BsModalRef;
  private loggedInProfile: sessionProfile;


  constructor(
    private commService: PlaybookCommunicationService,
    private modalService: BsModalService,
    private sessionStorageService: SessionStorageService,
    private storage: LocalStorageService
  ) { }

  ngOnInit() {
    this.loggedInProfile = this.sessionStorageService.getLoggedInProfileDetail();
    this.setButtonText();
    // to open add/edit challenge block modal when clicked from settings wrapper
    this.updateSubsciption = this.commService.getAddEditContentBlock().subscribe((contentBlockId) => {
      if (this.contentBlock.id === contentBlockId) {
        const initialState = {
          contentBlockId: this.contentBlock.id,
          playbookId: this.container.playbookId,
          adminId: this.loggedInProfile.id,
          challengeBlock: this.contentBlock.challengeBlock,
          sectionId: this.sectionId,
          pageId: this.container.id,
          isdraftmode: this.container.isCurrentPageInDraftMode
        };
        
        if ((window === window.parent || ( (window != window.parent) && window.location != window.parent.location ))) {
          this.addEditChallengeRef = this.modalService.show(AddEditChallengeBlockComponent,
            Object.assign({ initialState }, { class: 'custom-modal ' }, Modalconfig));
        } else {
          this.challengeContentSubscription = this.storage.observe('uploadChallengeContent')
          .subscribe((challengeBlock) => {
            if ((window !== window.parent && window.location == window.parent.location) && challengeBlock) {
              this.contentBlock.challengeBlock = clone(challengeBlock);
            }
            this.setButtonText();
          });
          this.storage.store("challengeContentBlock", {
            contentBlockId: this.contentBlock.id,
            playbookId: this.container.playbookId,
            adminId: this.loggedInProfile.id,
            challengeBlock: this.contentBlock.challengeBlock,
            sectionId: this.sectionId,
            pageId: this.container.id,
            isdraftmode: this.container.isCurrentPageInDraftMode
          });
        }
      }
    });
    if ((window === window.parent || ( (window != window.parent) && window.location != window.parent.location ))) {
      this.addUpdateChallengeBlock(); 
    }
  }

  /**
   * To handle added or updated challenge block
   */
  addUpdateChallengeBlock() {
    this.modalSubscription = this.modalService.onHide.subscribe(() => {
      if (this.addEditChallengeRef) {
        // setting added or updated challenge block in content block
        const challengeBlock = this.addEditChallengeRef.content.challengeBlock;
        if (challengeBlock) {
          this.contentBlock.challengeBlock = challengeBlock;
        }
        this.setButtonText();
      }
    });
  }

  /**
   * To handle settings wrapper
   * @param contentBlock ContentBlock object
   */
  articleClick(contentBlock) {
    if (contentBlock.type !== 0) {
      const menu = $(`#content-block-menu-${contentBlock.id}`);
      menu.css({
        width: $(`#contentblock-${contentBlock.id}`).closest('article.content').width() + 'px'
      });
      menu.show();
    }
    this.commService.sendSelectedContentBlockId(contentBlock.id);
    this.commService.sendSelectedContentBox(false);
  }

  /**
   * To set button text for challenge block
   */
  setButtonText() {
    if (this.contentBlock.challengeBlock && this.contentBlock.challengeBlock.buttonText) {
      this.buttonText = this.contentBlock.challengeBlock.buttonText;
    } else {
      this.buttonText = 'Go to the Challenge';
    }
  }

  ngOnDestroy() {
    if (this.updateSubsciption) {
      this.updateSubsciption.unsubscribe();
    }
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
    if (this.challengeContentSubscription) {
      this.challengeContentSubscription.unsubscribe();
      this.storage.store("uploadChallengeContent", null);
    }
  }
}
